import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { ZapIcon, TrendingUpIcon } from 'lucide-react';
export function UniqueMechanism() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full py-16 md:py-24 bg-white" data-id="element-98">
      <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-5xl" data-id="element-99">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} className="space-y-8" data-id="element-100">
          <div className="text-center space-y-4" data-id="element-101">
            <div className="inline-flex items-center gap-3 bg-[#f97316] text-white px-6 py-3 rounded-full font-bold text-lg" data-id="element-102">
              <ZapIcon className="w-6 h-6" data-id="element-103" />
              PRESENTAMOS
            </div>
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-[#1e3a8a]" data-id="element-104">
              El Método de Validación Ultra-Rápida
            </h2>
          </div>

          <div className="bg-gradient-to-br from-[#1e3a8a] to-[#1e2a5a] p-8 md:p-12 rounded-2xl shadow-2xl border-4 border-[#f97316]" data-id="element-105">
            <div className="space-y-6 text-white" data-id="element-106">
              <div className="flex items-start gap-4" data-id="element-107">
                <TrendingUpIcon className="w-12 h-12 text-[#f97316] flex-shrink-0" data-id="element-108" />
                <div className="space-y-4" data-id="element-109">
                  <p className="text-xl md:text-2xl font-semibold leading-relaxed" data-id="element-110">
                    En lugar de esperar a que el cliente venga a ti, activamos
                    tu red de contactos existente con una arquitectura de oferta
                    flash.
                  </p>

                  <p className="text-lg md:text-xl leading-relaxed text-[#faf8f5]" data-id="element-111">
                    Usamos el principio de{' '}
                    <span className="font-bold text-[#f97316]" data-id="element-112">
                      "Gas Moment"
                    </span>{' '}
                    (necesidad inmediata) para presentar una propuesta que sea
                    imposible de ignorar, diseñada específicamente para ser
                    aceptada en menos de dos días.
                  </p>

                  <div className="bg-[#f97316]/20 p-6 rounded-lg mt-6 border-l-4 border-[#f97316]" data-id="element-113">
                    <p className="text-lg font-medium" data-id="element-114">
                      Este método transforma tu red dormida en clientes activos,
                      aprovechando la urgencia psicológica y la confianza
                      preexistente para generar ventas inmediatas.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}